<template>
    <a
        v-if="useA"
        class="nav-bar-button"
        rel="noopener noreferrer"
        :href="link"
        target="_blank"
    >
        {{ label }}
    </a>
    <router-link v-else class="nav-bar-button" :to="link">
        {{ label }}
    </router-link>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: { label: String, link: String, useA: Boolean },
});
</script>

<style lang="scss">
@use "@/assets/global";

.nav-bar-button {
    padding: 10px;
    margin: 5px;

    text-decoration: none;
    font-size: 1.3rem;
    font-weight: bold;
    color: global.$bold-text-color;
    @media (prefers-color-scheme: dark) {
        color: global.$dark-theme-bold-text-color;
    }

    border-radius: 15px;
    border-style: solid;
    border-width: 3px;
    border-color: transparent;

    transition-property: border-color;
    transition-duration: 100ms;

    &.router-link-active {
        border-color: global.$accent-color;
        @media (prefers-color-scheme: dark) {
            border-color: global.$dark-theme-accent-color;
        }
    }
}
</style>
